<template>
  <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
    <template slot="right">
        <div class="select-box">
          <van-icon @click='onClickRight' name="ellipsis"/>
          <!-- 尖角选择列表 -->
          <div class="select-panel" v-show='showSelectPanel' ref="selectpanel">
            <div class="tri"></div>
            <ul>
              <li @click='goHome()'><img src="@/assets/parts/home.png"/>{{$t('T_BACK_TO_HOMEPAGE')}}</li>
              <li @click="selectLanguage"><img src="@/assets/parts/language.png"/>{{$t('T_LANGUAGE')}}</li>
            </ul>
          </div>
        </div>
        <div class="language-popup">
          <van-popup
            v-model="showLanguage"
            round
            closeable
            close-icon="close"
            position="bottom"
            :style="{width:'96%', margin:'0 2% 56px 2%'}"
          >
            <div class="language-content">
              <div class="language-title">{{$t('T_LANGUAGE')}}</div>
              <van-radio-group v-model="radioLanguage">
                <van-cell-group v-for="item in options" :key="item.value">
                  <van-cell clickable :title="$t(item.label)" @click="languagechange(item.value)">
                    <van-radio slot="right-icon" :name="item.value" />
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <div class="language-btn"><span @click="closePopup">{{$t('T_CANCEL')}}</span></div>
            </div>

          </van-popup>
        </div>
      </template>
  </van-nav-bar>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'Header',
  data () {
    return {
      showSelectPanel: false,
      showLanguage: false,
      options: [
        {
          value: 'ja',
          label: 'T_TOP_TITLE_LANGUAGE_JA'
        },
        {
          value: 'zh',
          label: 'T_TOP_TITLE_LANGUAGE_ZH'
        },
        {
          value: 'en',
          label: 'T_TOP_TITLE_LANGUAGE_EN'
        },
        {
          value: 'de',
          label: 'T_TOP_TITLE_LANGUAGE_DE'
        },
        {
          value: 'fr',
          label: 'T_TOP_TITLE_LANGUAGE_FR'
        },
        {
          value: 'it',
          label: 'T_TOP_TITLE_LANGUAGE_IT'
        },
        {
          value: 'es',
          label: 'T_TOP_TITLE_LANGUAGE_ES'
        },
        {
          value: 'pt-PT',
          label: 'T_TOP_TITLE_LANGUAGE_PT'
        },
        {
          value: 'ru',
          label: 'T_TOP_TITLE_LANGUAGE_RU'
        },
        {
          value: 'nl',
          label: 'T_TOP_TITLE_LANGUAGE_NL'
        },
        {
          value: 'da',
          label: 'T_TOP_TITLE_LANGUAGE_DA'
        },
        {
          value: 'fi',
          label: 'T_TOP_TITLE_LANGUAGE_FI'
        },
        {
          value: 'no',
          label: 'T_TOP_TITLE_LANGUAGE_NO'
        },
        {
          value: 'sv',
          label: 'T_TOP_TITLE_LANGUAGE_SV'
        },
        {
          value: 'cs',
          label: 'T_TOP_TITLE_LANGUAGE_CS'
        },
        {
          value: 'hu',
          label: 'T_TOP_TITLE_LANGUAGE_HU'
        },
        {
          value: 'pl',
          label: 'T_TOP_TITLE_LANGUAGE_PL'
        },
        {
          value: 'sk',
          label: 'T_TOP_TITLE_LANGUAGE_SK'
        },
        {
          value: 'bg',
          label: 'T_TOP_TITLE_LANGUAGE_BG'
        },
        {
          value: 'et',
          label: 'T_TOP_TITLE_LANGUAGE_ET'
        },
        {
          value: 'lv',
          label: 'T_TOP_TITLE_LANGUAGE_LV'
        },
        {
          value: 'lt',
          label: 'T_TOP_TITLE_LANGUAGE_LT'
        },
        {
          value: 'ro',
          label: 'T_TOP_TITLE_LANGUAGE_RO'
        },
        {
          value: 'el',
          label: 'T_TOP_TITLE_LANGUAGE_EL'
        },
        {
          value: 'tr',
          label: 'T_TOP_TITLE_LANGUAGE_TR'
        },
        {
          value: 'sl',
          label: 'T_TOP_TITLE_LANGUAGE_SL'
        },
        {
          value: 'hr',
          label: 'T_TOP_TITLE_LANGUAGE_HR'
        },
        {
          value: 'sr',
          label: 'T_TOP_TITLE_LANGUAGE_SR'
        },
        {
          value: 'ar',
          label: 'T_TOP_TITLE_LANGUAGE_AR'
        },
        {
          value: 'he',
          label: 'T_TOP_TITLE_LANGUAGE_HE'
        },
        {
          value: 'zh-TW',
          label: 'T_TOP_TITLE_LANGUAGE_ZH_TW'
        },
        {
          value: 'ko',
          label: 'T_TOP_TITLE_LANGUAGE_KO'
        },
        {
          value: 'ta',
          label: 'T_TOP_TITLE_LANGUAGE_TA'
        },
        {
          value: 'vi',
          label: 'T_TOP_TITLE_LANGUAGE_VI'
        },
        {
          value: 'bi',
          label: 'T_TOP_TITLE_LANGUAGE_BI'
        }
      ]
    }
  },

  props: {
    title: String,
    link: String
  },
  methods: {
    onClickLeft () {
      this.$emit('back')
      if (this.link === 'projectorInfo') {
        this.$router.push({ name: 'projectorInfo', params: { modelChange: false } })
      } else {
        this.$router.push({ path: '/' + this.link })
      }
    },
    onClickRight () {
      let selectpanel = this.$refs.selectpanel
      if (this.showSelectPanel) {
        this.showSelectPanel = false
      } else {
        this.showSelectPanel = true
      }
      if (this.language === 'sk') {
        selectpanel.style.width = '245px'
      } else if (this.language === 'en' || this.language === 'ja' || this.language === 'zh') {
        selectpanel.style.width = '183px'
      } else if (this.language === 'ru' || this.language === 'hr' || this.language === 'ro') {
        selectpanel.style.width = '260px'
      } else if (this.language === 'bg' || this.language === 'el') {
        selectpanel.style.width = '300px'
      } else {
        selectpanel.style.width = '230px'
      }
    },
    languagechange (val) {
      this.LANGUAGE(val)
      this.LANGUAGECHECKED(true)
      this.$i18n.locale = val
      this.showLanguage = false
      this.showSelectPanel = false
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    selectLanguage () {
      this.showLanguage = true
    },
    closePopup () {
      this.showLanguage = false
    },
    ...mapMutations(['LANGUAGE', 'LANGUAGECHECKED'])
  },

  computed: {
    ...mapState(['language']),
    radioLanguage: {
      get () {
        return this.language
      },
      set (val) {
        return this.LANGUAGE(val)
      }
    }
  }

}
</script>

<style scoped>

</style>
